import React from 'react';

import VWAMetaData from '../components/vwa-meta-data';
import VWA from './vwa';
import SearchProvider from '../../search-filter/components/search-container';
import { Helpers } from '../../core/src/helpers';

const { memoize } = Helpers;
//all fitlers tagged by analyzers are nested under facets.[filtername] so for any searches on root document fields need to be indicated

const mapSearchResults = (hit) => {
    return hit._source;
}

/**
 * Simple function that takes a search-filter query and counts number of filters
 * Since category or product group determin filter set ignore them as part of the filter count
 * @param {} query 
 */
const setFilterCount = (query) => {
    try{
        query = query || {};
        return Object.keys(query).filter(k => ['cat','pg'].indexOf(k) < 0).reduce((r, k) => {
            r += query[k].length;
            return r;
        },0);
    }catch(e){
        return 0;
    }
}

class VWAPage extends React.PureComponent {

    fetchProducts = (query={}, aggregations, sort, startPage, pageSize, searchKey) => {
      const { slugInfo, filterProducts } = this.props;
      const { components } = slugInfo;
      const { categoryFilters={} } = components;
      const { facets } = categoryFilters;

      //use first parent category or first category if none provided
      query.cat = query.cat || (facets.find((c) => c.location.indexOf('<<') < 0) || facets[0])._id;

      return filterProducts(query, aggregations, sort, startPage, pageSize, searchKey)
    }

    getCustomContext = memoize((searchKey, component) => {
        const { facets={} } = component || {};
        return {
          categories: facets
        };
    }, (searchKey, component) => {
      const { facets={} } = component || {};
      return `${searchKey}-${Object.keys(facets).length}`;
    });

    render(){
        const { slugInfo, match, location, defautSearch, urlFormatter, urlParser } = this.props;
        const { vanityUrl, components, seo } = slugInfo;
        const { categoryFilters, heroBanner } = components;
        const searchKey = vanityUrl || 'csr-fetching';

        return (
            <SearchProvider
                search={defautSearch}
                searchKey={searchKey}
                searchFunc={this.fetchProducts}
                resultMapper={mapSearchResults}
                urlSerialize={true}
                urlFormatter={urlFormatter}
                urlParser={urlParser}
                customContext={this.getCustomContext(searchKey, categoryFilters)}
                disableSearch={!vanityUrl}
                setFilterCount={setFilterCount}
            >
                <VWAMetaData 
                    seo={seo} 
                    key={'vwa-meta'}
                    useAlias={true} 
                    urlFormatter={urlFormatter}
                    match={match}
                    pathname={location.pathname}
                />
                <VWA 
                    categoryFilters={categoryFilters} 
                    key={`vwa-results`}
                    heroBanner={heroBanner}
                />
            </SearchProvider>
        );
    }
}

export default VWAPage
